export const GET_EMAIL_TEMPLATES = 'GET_EMAIL_TEMPLATES';
export const UPDATE_EMAIL_TEMPLATE = 'UPDATE_EMAIL_TEMPLATE';
export const SHOW_UPDATE_TEMPLATE_CONFIRMATION = 'SHOW_UPDATE_TEMPLATE_CONFIRMATION';
export const HIDE_UPDATE_TEMPLATE_CONFIRMATION = 'HIDE_UPDATE_TEMPLATE_CONFIRMATION';
export const SEND_TEST_EMAIL = 'SEND_TEST_EMAIL';
export const HANDLE_ERROR = 'HANDLE_ERROR';